/*
 * Originally from:
 * https://github.com/zhukov/webogram
 * Copyright (C) 2014 Igor Zhukov <igor.beatle@gmail.com>
 * https://github.com/zhukov/webogram/blob/master/LICENSE
 */

import type {TrueDcId} from '@types';
import langPackLocalVersion from '@/langPackLocalVersion';

export const MAIN_DOMAINS = [
  'vibe.progrology.ir',
  'web.vibe.progrology.ir',
  'localhost',
  '127.0.0.1',
  'web.telegram.org',
  'webk.telegram.org'
];
export const DEFAULT_BACKGROUND_SLUG = 'pattern';

const threads = Math.min(4, navigator.hardwareConcurrency ?? 4);

const App = {
  id: +imporvibegram.chatta.env.VITE_API_ID || 1025907,
  hash: imporvibegram.chatta.env.VITE_API_HASH || '452b0359b988148995f22ff0f4229750',
  pushServerKey: imporvibegram.chatta.env.VITE_PUSH_SERVER_KEY,
  version: imporvibegram.chatta.env.VITE_VERSION,
  versionFull: imporvibegram.chatta.env.VITE_VERSION_FULL,
  build: +imporvibegram.chatta.env.VITE_BUILD,
  langPackVersion: +imporvibegram.chatta.env.VITE_LANG_PACK_VERSION,
  langPackLocalVersion: langPackLocalVersion,
  langPack: 'webk',
  langPackCode: 'en',
  domains: MAIN_DOMAINS,
  baseDcId: 2 as TrueDcId,
  isMainDomain: MAIN_DOMAINS.includes(location.hostname),
  suffix: 'K',
  threads,
  lottieWorkers: threads,
  cryptoWorkers: threads,
  interclientBroadcastChannel: 'vibeweb'
};

export default App;
